import base from "@/themes/base/base";

export const ChartName = {
    CHART: "Chart",
    COCKPIT: "Cockpit",
    ALTITUDE: "altitude",
    AIRSPEED: "airspeed",
    LOOKOUT: "LookoutProcedure",
    LASER: "Laser",
    FIRINGHIT: "FiringHit",
    FIRINGMISS: "FiringMiss",
    OFFROADEVENTS: "OffRoadEvents",
    HARSHBRAKING: "HarshBraking",
    COLLISIONS: "Collisions",
    SPEED: "Speed",
    BLINDSPOTCHECK: "BlindspotCheck",
};

//Radar chart
export const RadarColors = {
    AchievedScore: base.colors.neutral.grey[50],
    ExpectedScore: base.colors.primary.orange[500],
};
